import makeStyles from '@mui/styles/makeStyles';
import { Box, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import { PayRateFormProps, RTAParameter } from '../../../interfaces/PayRate';
import { generateNumberInput } from '../../../utilities/PayRates';

export const RTAParameterForm = (props: PayRateFormProps) => {
  const classes = useStyles();

  const rtaParameter = props.currentState as RTAParameter;

  return (
    <Box component='div' className={classes.formWrapper}>
      <Box className={classes.row}>
        <Box component='div' className={classes.numberField}>
          {generateNumberInput<RTAParameter>(
            true,
            true,
            rtaParameter,
            props.setter,
            'guardrailLowerBound',
            props.isDisabled,
            'Lower Bound',
            -15,
            '',
            undefined,
            false,
            false,
            true,
            0,
          )}
        </Box>
        <Box component='div' className={classes.numberField}>
          {generateNumberInput<RTAParameter>(
            true,
            true,
            rtaParameter,
            props.setter,
            'guardrailUpperBound',
            props.isDisabled,
            'Upper Bound',
            0,
            '',
            undefined,
            false,
            false,
            true,
            15,
          )}
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
    },
    row: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'row',
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
    numberField: {
      width: 160,
      marginRight: theme.spacing(2),
    },
    isStarbucksSwitch: {
      marginLeft: theme.spacing(1.5),
    },
  }),
);
